module.exports = __webpack_public_path__ + "static/media/avater.31316905.jpg";